import * as React from 'react';
import { renderEmpty } from '../../common/Render';
import translate from '../../../../locale/translate';

import { IReportSettings } from '../../../../interfaces';

import ISettings from './ISettings';
import StateTable from './StateTable';
import { IWidgetProps } from '../../StateWidgetContainer';

interface IProps extends IWidgetProps {
    settings: ISettings;
}

export default class Widget extends React.Component<IProps, void> {
    static propTypes = {
        nodes: React.PropTypes.array.isRequired,
        states: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderData(nodes, states, settings) {
        const byParent = nodes.reduce((map, node) => {
            const parentId = node._searchIdx.parentNames.slice(2).join(' / ');

            if (!map[parentId]) {
                map[parentId] = [];
            }

            map[parentId].push(node);

            return map;
        }, {});

        const parents = Object.keys(byParent).sort();

        return parents.map(function (parent) {
            const parentKey = `parent-${parent}`;

            const children = byParent[parent].map((node) => {
                const nodeKey = `node-${node.id}`;
                return (
                    <div key={nodeKey}>
                        <StateTable node={node} states={states[node.id]} withState settings={settings} />
                    </div>
                );
            });

            return (
                <div key={parentKey} className="space-xl">
                    <h4>{parent}</h4>
                    {children}
                </div>
            );
        });
    }

    render() {
        let { nodes } = this.props;
        const { states, settings, reportSettings } = this.props;
        let nodeTotal = nodes.length;

        if (!settings.displayWithoutAlerts) {
            nodes = nodes.filter(node => {
                states[node.id] = (states[node.id] || []).filter(state => state.state === true);
                return !!states[node.id].length;
            });
        }

        let renderedData;
        if (nodeTotal && nodes.length) {
            renderedData = this.renderData(nodes, states, settings);
        } else if (nodeTotal) {
            renderedData = renderEmpty(translate.gettext("No alerts occured"), translate.gettext("No alerts where recorded within that timespan"));
        } else {
            renderedData = renderEmpty();
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/listAlerts/Widget.tsx